import { linkifyGoAndTrack } from "@/lib/goAndTrack";

export default function PageHero({
  eyebrow,
  title,
  subtitle,
  children,
}) {
  return (
    <section
      data-testid="page-hero"
      className="relative border-b border-line bg-white"
    >
      <div className="absolute inset-0 grid-backdrop opacity-50 pointer-events-none" />
      <div className="container-x relative section">
        <div className="max-w-3xl">
          {eyebrow && <p className="eyebrow mb-5">{eyebrow}</p>}
          <h1 className="h1">{title}</h1>
          {subtitle && <p className="lead mt-6 max-w-2xl">{linkifyGoAndTrack(subtitle)}</p>}
          {children && <div className="mt-8 flex flex-wrap gap-3">{children}</div>}
        </div>
      </div>
    </section>
  );
}
